import React from "react";
import { connect } from "react-redux";
import { Modal, Icon, Button } from "semantic-ui-react";
import PropTypes from "prop-types";

function TestoPrivacy({ datiScuola, t, isOpen, onClose, numRichiesta }) {
  if (!datiScuola || Object.keys(datiScuola).length === 0) return null;

  const translate = (key, defaultVal) => {
    if (typeof t === "function") {
      const res = t(key);
      if (res && res !== key) return res;
    }
    return defaultVal;
  };

  const getTitle = () => {
    if (numRichiesta === 2 && datiScuola.titoloPrivacy2) {
      return datiScuola.titoloPrivacy2;
    }
    if (numRichiesta === 3 && datiScuola.titoloPrivacy3) {
      return datiScuola.titoloPrivacy3;
    }
    return translate("informativa_trattamento", "Informativa sul trattamento dei dati personali");
  };

  const getHtmlContent = () => {
    let text = "";
    if (numRichiesta === undefined) {
      text = datiScuola.testoPrivacy || "";
    } else if (numRichiesta === 2) {
      text = datiScuola.testoPrivacy2 || "";
    } else if (numRichiesta === 3) {
      text = datiScuola.testoPrivacy3 || "";
    }
    return text.replace(/\n/g, "<br>");
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      size="large"
      closeIcon
    >
      <Modal.Header>
        <Icon name="shield alternate" />
        {getTitle()}
      </Modal.Header>
      <Modal.Content scrolling>
        <p
          style={{ textAlign: "justify", lineHeight: "1.6" }}
          dangerouslySetInnerHTML={{
            __html: getHtmlContent(),
          }}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button
          onClick={onClose}
          icon="cancel"
          content={translate("chiudi", translate("annulla", "Chiudi"))}
        />
      </Modal.Actions>
    </Modal>
  );
}

TestoPrivacy.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  t: PropTypes.func,
  numRichiesta: PropTypes.number,
};

function mapStateToProps(state) {
  return {
    datiScuola: state.scuolaReducer,
  };
}

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TestoPrivacy);

